module.exports = __webpack_public_path__ + "static/Logo@0.25x-c37f207900312b1b823a17c53b44faf0.png";